import React from "react";
import PropTypes from "prop-types";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import styles from "./styles.css";


const ScreenReaderLabel = ({ children, htmlFor }) => isNonEmptyString(htmlFor)
	? <label className={styles.screenReaderLabel} htmlFor={htmlFor}>{children}</label>
	: "";

ScreenReaderLabel.propTypes = {
	children: PropTypes.node.isRequired,
	htmlFor: PropTypes.string
};

export default ScreenReaderLabel;